import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-32910909"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "about-wrap"
};
var _hoisted_2 = {
  key: 0
};
import { useRoute, useRouter } from "vue-router";
import { reactive, getCurrentInstance, onMounted, ref } from "vue";
// import VConsole from "vconsole";

export default {
  __name: 'About',
  setup: function setup(__props) {
    var _useRoute = useRoute(),
      query = _useRoute.query;
    var router = useRouter();
    var instance = getCurrentInstance();
    // let vconsole = new VConsole();
    // vconsole.destroy();

    var themeVars = reactive({
      navBarIconColor: "#323232",
      navBarTitleFontSize: "17px"
    });
    var privacyLink = ref("");
    var serviceLink = ref("");
    var thirdPartySdkLink = ref("");
    var appVersion = ref("");
    var forbidBack = function forbidBack() {
      var isBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      instance.proxy.$xsyxBridge.shouldBlockPopGesture({
        isBlock: isBlock
      });
    };
    instance.proxy.$xsyxBridge.showToolBar({
      show: false
    });
    var skipTo = function skipTo(url, title) {
      var _location = location,
        protocol = _location.protocol,
        host = _location.host,
        pathname = _location.pathname;
      instance.proxy.$xsyxBridge.pushPage({
        url: protocol + host + pathname + "/#/iframe",
        params: {
          src: url.value,
          title: title
        }
      });
    };
    var sysInfo = reactive([{
      title: "隐私政策",
      action: skipTo.bind(null, privacyLink, "隐私政策")
    }, {
      title: "用户协议",
      action: skipTo.bind(null, serviceLink, "用户协议")
    }]);
    var goBack = function goBack() {
      instance.proxy.$xsyxBridge.popBack();
    };
    var fetchProdData = function fetchProdData() {
      var _query$version = query.version,
        version = _query$version === void 0 ? "0.0.15" : _query$version,
        _query$appId = query.appId,
        appId = _query$appId === void 0 ? "com.xsyxsc.tdb" : _query$appId;
      if (!version || !appId) _Notify({
        type: "danger",
        message: "version和appId不能为空！"
      });
      if (version) appVersion.value = "V" + version;
      instance === null || instance === void 0 || instance.proxy.$api.getApplicationInfo({
        version: version,
        appId: appId
      }).then(function (response) {
        var data = response.data,
          code = response.code;
        if (code === 200) {
          console.log("data", data);
          var privacyAgreement = data.privacyAgreement,
            serviceAgreement = data.serviceAgreement,
            thirdPartySdkDirectory = data.thirdPartySdkDirectory;
          privacyLink.value = privacyAgreement;
          serviceLink.value = serviceAgreement;
          thirdPartySdkLink.value = thirdPartySdkDirectory;
          if (thirdPartySdkDirectory) {
            sysInfo.push({
              title: "第三方SDK目录",
              action: skipTo.bind(null, thirdPartySdkLink, "第三方SDK目录")
            });
          }
        }
      });
    };
    var navHeight = ref("");
    onMounted(function () {
      navHeight.value = window.deviceInfo.statusBarHeight;
      forbidBack();
      setTimeout(function () {
        instance.proxy.$vconsole.destroy();
      }, 0);
      fetchProdData();
    });
    instance.proxy.$xsyxBridge.webViewWillAppear({
      success: function success() {
        forbidBack();
      }
    });
    return function (_ctx, _cache) {
      var _component_van_nav_bar = _resolveComponent("van-nav-bar");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_nav_bar, {
            onClickLeft: goBack,
            fixed: "",
            "left-arrow": "",
            style: _normalizeStyle({
              'padding-top': navHeight.value + 'px'
            }),
            title: "关于我们"
          }, null, 8, ["style"]), _createElementVNode("div", {
            class: "content",
            style: _normalizeStyle({
              'margin-top': parseInt(55) + 'px'
            })
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sysInfo), function (item, index) {
            return _openBlock(), _createBlock(_component_van_cell_group, {
              inset: "",
              key: index
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_van_cell, {
                  title: item.title,
                  onClick: item.action
                }, {
                  value: _withCtx(function () {
                    return [item.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.value), 1)) : _createCommentVNode("", true), _createVNode(_component_van_icon, {
                      name: "arrow"
                    })];
                  }),
                  _: 2
                }, 1032, ["title", "onClick"])];
              }),
              _: 2
            }, 1024);
          }), 128))], 4)];
        }),
        _: 1
      }, 8, ["theme-vars"])]);
    };
  }
};